/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        '服务正在从缓存中为应用程序提供服务。\n' +
          '有关更多详细信息，请访问 https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('服务已注册。')
    },
    cached () {
      console.log('内容已缓存以供脱机使用。')
    },
    updatefound () {
      console.log('正在下载新内容。')
    },
    updated () {
      console.log('新内容可用；请刷新。')
    },
    offline () {
      console.log('找不到internet连接。应用程序正在脱机模式下运行。')
    },
    error (error) {
      console.error('服务工作者注册过程中出错：', error)
    }
  })
}
